// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2W_w3","footer":"ModalError_footer__2b1uY"};